import React from 'react';
import NavigationBar from '../nav_bar/navigation_bar';
import Contact from '../contact/contact';

const ContactPage = () => {
    return (
        <div className="contact-page">
            <NavigationBar />

            <main className="contact-main">
                <Contact />
            </main>

        </div>
    );
};

export default ContactPage;